/**
 * @deprecated Please use optional parameter and optional chaining instead
 */
export default function noop() {
  // noop
}
